
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/[company_slug]",
      function () {
        return require("private-next-pages/site/[company_slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/[company_slug]"])
      });
    }
  